module.exports = __webpack_public_path__ + "static/calendar-year-2019-2020-475218127423ebdeff69cf71f5243ac5.png";